"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldVector = exports.ModelMutatorVector = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var geodesic_1 = require("../../../geo/geodesic");
var math_1 = require("../../../math");
var unit_1 = require("../../../unit");
var collection_field_1 = require("../collection.field");
var ModelMutatorVector = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorVector, _super);
    function ModelMutatorVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorVector.prototype.manual = function (newValue) {
        if (newValue == null || (newValue.distance == null && newValue.bearing == null)) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        // Force the vector to be between 0 and two Pi
        newValue.bearing = unit_1.IkeAngle.normalize(newValue.bearing);
        // Sometimes pitch is not set, It is a required field
        if (newValue.pitch == null || isNaN(newValue.pitch)) {
            newValue.pitch = 0;
        }
        this.state.setFieldValue(this.field.id, {
            provider: CollectionModelFieldVector.PROVIDER_MANUAL,
            value: newValue
        });
    };
    ModelMutatorVector.prototype.p2p = function (state) {
        if (!Array.isArray(state)) {
            throw new Error("Field ".concat(this.field.id, ": Invalid capture state."));
        }
        if (state.length < 2) {
            throw new Error("Field ".concat(this.field.id, ": Invalid capture count \"").concat(state.length, "\"."));
        }
        this.state.setFieldValue(this.field.id, {
            provider: CollectionModelFieldVector.PROVIDER_P2P,
            captures: state.slice()
        });
    };
    ModelMutatorVector.prototype.collection = function (collectionId) {
        if (collectionId == null) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        this.state.setFieldValue(this.field.id, {
            provider: CollectionModelFieldVector.PROVIDER_COLLECTION,
            collectionId: collectionId
        });
    };
    ModelMutatorVector.prototype.reverse = function () {
        if (!this.field.hasValue()) {
            return;
        }
        if (this.field.isPointToPoint()) {
            var captures = this.field.stateValue.
                captures.slice().reverse();
            this.p2p(captures);
            return;
        }
        if (this.field.isManual()) {
            var value = this.field.value;
            this.manual({
                distance: value.distance,
                bearing: unit_1.IkeAngle.flip(value.bearing),
                pitch: value.pitch
            });
        }
    };
    ModelMutatorVector.prototype.copy = function (from) {
        if (from.isPointToPoint()) {
            this.p2p(from.stateValue.captures);
            return true;
        }
        if (from.isCollectionLink()) {
            var targetCollection = from.getCollections()[0];
            // Dont link to ourself
            if (targetCollection == null) {
                return true;
            }
            if (targetCollection.collectionId === this.field.collection.id) {
                var otherCollection = from.collection;
                this.collection(otherCollection.id);
                return true;
            }
            this.collection(targetCollection.collectionId);
            return true;
        }
        if (from.isManual()) {
            this.manual(from.value);
            return true;
        }
        return false;
    };
    return ModelMutatorVector;
}(collection_field_1.ModelMutator));
exports.ModelMutatorVector = ModelMutatorVector;
var CollectionModelFieldVector = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldVector, _super);
    function CollectionModelFieldVector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldVector.isVectorField = function (f) {
        return f.schema.type === CollectionModelFieldVector.TYPE;
    };
    Object.defineProperty(CollectionModelFieldVector.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorVector(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVector.prototype, "value", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            if (stateValue.provider === CollectionModelFieldVector.PROVIDER_MANUAL) {
                return stateValue.value;
            }
            if (stateValue.provider === CollectionModelFieldVector.PROVIDER_P2P) {
                var vectorValue = math_1.MultiPoint.Points(this.getCaptures());
                // To be backwards compatible, vertical values should not have a sign on them
                vectorValue.vertical = Math.abs(vectorValue.vertical);
                return vectorValue;
            }
            if (stateValue.provider === CollectionModelFieldVector.PROVIDER_COLLECTION) {
                var collection = this.collection;
                var sourceLocation = collection.location;
                if (sourceLocation == null) {
                    return null;
                }
                var targetLocation = void 0;
                // Try to get the current location state
                var targetCollectionModel = collection.state.getCollectionModel(stateValue.collectionId);
                if (targetCollectionModel == null) {
                    // If the current state is not available, then get the DB stored location data
                    var targetCollection = collection.state.getCollection(stateValue.collectionId);
                    if (targetCollection == null) {
                        return null;
                    }
                    targetLocation = core_api_1.ParseJSON.fromGeoPoint(targetCollection.location);
                }
                else {
                    targetLocation = targetCollectionModel.location;
                }
                if (targetLocation == null) {
                    return null;
                }
                return geodesic_1.IkeGeodesic.getVector(sourceLocation, targetLocation);
            }
            throw new Error("Field ".concat(this.id, ": Invalid Provider type \"").concat(stateValue['provider'], "\""));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVector.prototype, "provider", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null || stateValue.provider == null) {
                return CollectionModelFieldVector.PROVIDER_MANUAL;
            }
            return stateValue.provider;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldVector.prototype.isManual = function () {
        return this.provider === CollectionModelFieldVector.PROVIDER_MANUAL;
    };
    CollectionModelFieldVector.prototype.isPointToPoint = function () {
        return this.provider === CollectionModelFieldVector.PROVIDER_P2P;
    };
    CollectionModelFieldVector.prototype.isCollectionLink = function () {
        return this.provider === CollectionModelFieldVector.PROVIDER_COLLECTION;
    };
    CollectionModelFieldVector.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldVector.prototype.getCaptures = function () {
        var captures = [];
        var captureIds = this.getCaptureIds();
        for (var _i = 0, captureIds_1 = captureIds; _i < captureIds_1.length; _i++) {
            var captureId = captureIds_1[_i];
            var capture = this.collection.state.getCapture(captureId);
            if (capture == null) {
                return [];
            }
            if (capture.orientation == null) {
                throw new Error("Invalid truesize capture '".concat(capture.objectId, "' for field '").concat(this.id, "' (missing orientation)"));
            }
            if (capture.calibrationid == null) {
                throw new Error("Invalid truesize capture '".concat(capture.objectId, "' for field '").concat(this.id, "' (missing calibrationId)"));
            }
            captures.push(capture);
        }
        return captures;
    };
    CollectionModelFieldVector.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldVector.prototype.getCaptureIds = function () {
        if (!this.isPointToPoint()) {
            return [];
        }
        return this.stateValue.captures;
    };
    CollectionModelFieldVector.prototype.getTargetModel = function () {
        if (!this.isCollectionLink()) {
            return null;
        }
        return this.collection.state.getCollectionModel(this.stateValue.collectionId);
    };
    CollectionModelFieldVector.prototype.getTargetJson = function () {
        if (!this.isCollectionLink()) {
            return null;
        }
        return this.collection.state.getCollection(this.stateValue.collectionId);
    };
    /**
     * @deprecated Use getTargetJson or getTargetModel instead
     */
    CollectionModelFieldVector.prototype.getCollections = function () {
        var _this = this;
        // There is no reason for this to be an array result when you can only link to one collection
        return this.getCollectionIds().map(function (c) { return _this.collection.state.getCollection(c); });
    };
    /**
     * @deprecated Use getTargetJson or getTargetModel instead
     */
    CollectionModelFieldVector.prototype.getCollectionIds = function () {
        // There is no reason for this to be an array result when you can only link to one collection
        if (!this.isCollectionLink()) {
            return [];
        }
        return [this.stateValue.collectionId];
    };
    CollectionModelFieldVector.prototype.hasValue = function () {
        return this.value != null;
    };
    /**
     * An async method which is guaranteed to load the linked CollectionModel.
     * Can be used to force the linked collection to load before using `value` or `hasValue`.
     */
    CollectionModelFieldVector.prototype.getLinkedCollection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (((_a = this.stateValue) === null || _a === void 0 ? void 0 : _a.provider) !== CollectionModelFieldVector.PROVIDER_COLLECTION) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.collection.state.getCollectionModelAsync(this.stateValue.collectionId)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    CollectionModelFieldVector.PROVIDER_MANUAL = 'manual';
    CollectionModelFieldVector.PROVIDER_P2P = 'pointtopoint';
    CollectionModelFieldVector.PROVIDER_COLLECTION = 'collection';
    CollectionModelFieldVector.TYPE = core_api_1.IkeFieldType.VECTOR;
    return CollectionModelFieldVector;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldVector = CollectionModelFieldVector;
//# sourceMappingURL=vector.field.js.map